import { ReactNode } from 'react';
import styled from 'styled-components';

const StyledDoctorSpecialtiesSection = styled.section`
   display: flex;
   flex-direction: column;
   gap: 8px;
`;

StyledDoctorSpecialtiesSection.displayName = 'StyledDoctorSpecialtiesSection';

type DoctorSpecialtiesSectionProps = {
   readonly children: ReactNode;
};

export const DoctorSpecialtiesSection = (props: DoctorSpecialtiesSectionProps): JSX.Element => {
   return <StyledDoctorSpecialtiesSection>{props.children}</StyledDoctorSpecialtiesSection>;
};
